import {Component, Input, OnInit} from '@angular/core';
import {IndicatorPurifierInterface, IndicatorPurifierStateInterface} from '../../../interfaces/simulator-entry';

@Component({
  selector: 'app-indicator-purifier-entry',
  templateUrl: './indicator-purifier-entry.component.html',
  styleUrls: ['./indicator-purifier-entry.component.sass']
})
export class IndicatorPurifierEntryComponent implements OnInit {

  @Input() data: IndicatorPurifierInterface;
  public state;

  constructor() {
    this.state = IndicatorPurifierStateInterface;
  }

  ngOnInit() {
    console.groupCollapsed('Simulator - Indicator - Purifier');
    console.log('ngOnInit state: ', this.data);
    console.groupEnd();
  }

}
